// from https://github.com/kentcdodds/use-deep-compare-effect
import * as React from "react";
import { useDeepCompareMemoize } from "..";
export function useDeepCompareMemo(factory, dependencies) {
    // type cast to prevent issue with new @types/react version
    return React.useMemo(factory, useDeepCompareMemoize(dependencies));
}
//# sourceMappingURL=useDeepCompareMemo.js.map